'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var _createClass = function () {
    function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor)
                descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function (Constructor, protoProps, staticProps) {
        if (protoProps)
            defineProperties(Constructor.prototype, protoProps);
        if (staticProps)
            defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var _utils = require('./utils');
var _utils2 = _interopRequireDefault(_utils);
var _thumbnails = require('./thumbnails');
var _thumbnails2 = _interopRequireDefault(_thumbnails);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
var Controller = function () {
    function Controller(player) {
        var _this = this;
        _classCallCheck(this, Controller);
        this.player = player;
        this.autoHideTimer = 0;
        if (!_utils2.default.isMobile) {
            this.player.container.addEventListener('mousemove', function () {
                _this.setAutoHide();
            });
            this.player.container.addEventListener('click', function () {
                _this.setAutoHide();
            });
        }
        this.initPlayButton();
        this.initThumbnails();
        this.initPlayedBar();
        this.initFullButton();
        this.initVolumeButton();
        this.initQualityButton();
        this.initScreenshotButton();
        this.initSubtitleButton();
    }
    _createClass(Controller, [
        {
            key: 'initPlayButton',
            value: function initPlayButton() {
                var _this2 = this;
                this.player.template.playButton.addEventListener('click', function () {
                    _this2.player.toggle();
                });
                if (!_utils2.default.isMobile) {
                    this.player.template.videoWrap.addEventListener('click', function () {
                        _this2.player.toggle();
                    });
                    this.player.template.controllerMask.addEventListener('click', function () {
                        _this2.player.toggle();
                    });
                } else {
                    this.player.template.videoWrap.addEventListener('click', function () {
                        _this2.toggle();
                    });
                    this.player.template.controllerMask.addEventListener('click', function () {
                        _this2.toggle();
                    });
                }
            }
        },
        {
            key: 'initThumbnails',
            value: function initThumbnails() {
                var _this3 = this;
                if (this.player.options.video.thumbnails) {
                    this.thumbnails = new _thumbnails2.default({
                        container: this.player.template.barPreview,
                        barWidth: this.player.template.barWrap.offsetWidth,
                        url: this.player.options.video.thumbnails,
                        events: this.player.events
                    });
                    this.player.on('loadedmetadata', function () {
                        _this3.thumbnails.resize(160, _this3.player.video.videoHeight / _this3.player.video.videoWidth * 160);
                    });
                }
            }
        },
        {
            key: 'initPlayedBar',
            value: function initPlayedBar() {
                var _this4 = this;
                var thumbMove = function thumbMove(e) {
                    var percentage = (e.clientX - _utils2.default.getElementViewLeft(_this4.player.template.playedBarWrap)) / _this4.player.template.playedBarWrap.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this4.player.bar.set('played', percentage, 'width');
                    _this4.player.template.ptime.innerHTML = _utils2.default.secondToTime(percentage * _this4.player.video.duration);
                };
                var thumbUp = function thumbUp(e) {
                    document.removeEventListener('mouseup', thumbUp);
                    document.removeEventListener('mousemove', thumbMove);
                    var percentage = (e.clientX - _utils2.default.getElementViewLeft(_this4.player.template.playedBarWrap)) / _this4.player.template.playedBarWrap.clientWidth;
                    percentage = Math.max(percentage, 0);
                    percentage = Math.min(percentage, 1);
                    _this4.player.bar.set('played', percentage, 'width');
                    _this4.player.seek(_this4.player.bar.get('played') * _this4.player.video.duration);
                    _this4.player.time.enable('progress');
                };
                this.player.template.playedBarWrap.addEventListener('mousedown', function () {
                    _this4.player.time.disable('progress');
                    document.addEventListener('mousemove', thumbMove);
                    document.addEventListener('mouseup', thumbUp);
                });
                this.player.template.playedBarWrap.addEventListener('mousemove', function (e) {
                    if (_this4.player.video.duration) {
                        var px = _utils2.default.cumulativeOffset(_this4.player.template.playedBarWrap).left;
                        var tx = e.clientX - px;
                        if (tx < 0 || tx > _this4.player.template.playedBarWrap.offsetWidth) {
                            return;
                        }
                        var time = _this4.player.video.duration * (tx / _this4.player.template.playedBarWrap.offsetWidth);
                        _this4.thumbnails && _this4.thumbnails.move(tx);
                        _this4.player.template.playedBarTime.style.left = tx - 20 + 'px';
                        _this4.player.template.playedBarTime.innerText = _utils2.default.secondToTime(time);
                        _this4.player.template.playedBarTime.classList.remove('hidden');
                    }
                });
                this.player.template.playedBarWrap.addEventListener('mouseenter', function () {
                    if (_this4.player.video.duration) {
                        _this4.thumbnails && _this4.thumbnails.show();
                        _this4.player.template.playedBarTime.classList.remove('hidden');
                    }
                });
                this.player.template.playedBarWrap.addEventListener('mouseleave', function () {
                    if (_this4.player.video.duration) {
                        _this4.thumbnails && _this4.thumbnails.hide();
                        _this4.player.template.playedBarTime.classList.add('hidden');
                    }
                });
            }
        },
        {
            key: 'initFullButton',
            value: function initFullButton() {
                var _this5 = this;
                this.player.template.browserFullButton.addEventListener('click', function () {
                    _this5.player.fullScreen.toggle('browser');
                });
                this.player.template.webFullButton.addEventListener('click', function () {
                    _this5.player.fullScreen.toggle('web');
                });
            }
        },
        {
            key: 'initVolumeButton',
            value: function initVolumeButton() {
                var _this6 = this;
                var vWidth = 35;
                var volumeMove = function volumeMove(event) {
                    var e = event || window.event;
                    var percentage = (e.clientX - _utils2.default.getElementViewLeft(_this6.player.template.volumeBarWrap) - 5.5) / vWidth;
                    _this6.player.volume(percentage);
                };
                var volumeUp = function volumeUp() {
                    document.removeEventListener('mouseup', volumeUp);
                    document.removeEventListener('mousemove', volumeMove);
                    _this6.player.template.volumeButton.classList.remove('dplayer-volume-active');
                };
                this.player.template.volumeBarWrapWrap.addEventListener('click', function (event) {
                    var e = event || window.event;
                    var percentage = (e.clientX - _utils2.default.getElementViewLeft(_this6.player.template.volumeBarWrap) - 5.5) / vWidth;
                    _this6.player.volume(percentage);
                });
                this.player.template.volumeBarWrapWrap.addEventListener('mousedown', function () {
                    document.addEventListener('mousemove', volumeMove);
                    document.addEventListener('mouseup', volumeUp);
                    _this6.player.template.volumeButton.classList.add('dplayer-volume-active');
                });
                this.player.template.volumeIcon.addEventListener('click', function () {
                    if (_this6.player.video.muted) {
                        _this6.player.video.muted = false;
                        _this6.player.switchVolumeIcon();
                        _this6.player.bar.set('volume', _this6.player.volume(), 'width');
                    } else {
                        _this6.player.video.muted = true;
                        _this6.player.template.volumeIcon.innerHTML = _this6.player.icons.get('volume-off');
                        _this6.player.bar.set('volume', 0, 'width');
                    }
                });
            }
        },
        {
            key: 'initQualityButton',
            value: function initQualityButton() {
                var _this7 = this;
                if (this.player.options.video.quality) {
                    this.player.template.qualityList.addEventListener('click', function (e) {
                        if (e.target.classList.contains('dplayer-quality-item')) {
                            _this7.player.switchQuality(e.target.dataset.index);
                        }
                    });
                }
            }
        },
        {
            key: 'initScreenshotButton',
            value: function initScreenshotButton() {
                var _this8 = this;
                if (this.player.options.screenshot) {
                    this.player.template.camareButton.addEventListener('click', function () {
                        var canvas = document.createElement('canvas');
                        canvas.width = _this8.player.video.videoWidth;
                        canvas.height = _this8.player.video.videoHeight;
                        canvas.getContext('2d').drawImage(_this8.player.video, 0, 0, canvas.width, canvas.height);
                        var dataURL = canvas.toDataURL();
                        _this8.player.template.camareButton.href = dataURL;
                        _this8.player.template.camareButton.download = 'DPlayer.png';
                        _this8.player.events.trigger('screenshot', dataURL);
                    });
                }
            }
        },
        {
            key: 'initSubtitleButton',
            value: function initSubtitleButton() {
                var _this9 = this;
                if (this.player.options.subtitle) {
                    this.player.events.on('subtitle_show', function () {
                        _this9.player.template.subtitleButton.dataset.balloon = _this9.player.tran('Hide subtitle');
                        _this9.player.template.subtitleButtonInner.style.opacity = '';
                        _this9.player.user.set('subtitle', 1);
                    });
                    this.player.events.on('subtitle_hide', function () {
                        _this9.player.template.subtitleButton.dataset.balloon = _this9.player.tran('Show subtitle');
                        _this9.player.template.subtitleButtonInner.style.opacity = '0.4';
                        _this9.player.user.set('subtitle', 0);
                    });
                    this.player.template.subtitleButton.addEventListener('click', function () {
                        _this9.player.subtitle.toggle();
                    });
                }
            }
        },
        {
            key: 'setAutoHide',
            value: function setAutoHide() {
                var _this10 = this;
                this.show();
                clearTimeout(this.autoHideTimer);
                this.autoHideTimer = setTimeout(function () {
                    if (_this10.player.video.played.length && !_this10.disableAutoHide) {
                        _this10.hide();
                    }
                }, 2000);
            }
        },
        {
            key: 'show',
            value: function show() {
                this.player.container.classList.remove('dplayer-hide-controller');
            }
        },
        {
            key: 'hide',
            value: function hide() {
                this.player.container.classList.add('dplayer-hide-controller');
                this.player.setting.hide();
                this.player.comment && this.player.comment.hide();
            }
        },
        {
            key: 'isShow',
            value: function isShow() {
                return !this.player.container.classList.contains('dplayer-hide-controller');
            }
        },
        {
            key: 'toggle',
            value: function toggle() {
                if (this.isShow()) {
                    this.hide();
                } else {
                    this.show();
                }
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                clearTimeout(this.autoHideTimer);
            }
        }
    ]);
    return Controller;
}();
exports.default = Controller;


//////////////////
// WEBPACK FOOTER
// ./src/js/controller.js
// module id = 17
// module chunks = 0